import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import TemplateCreateContent from "../../../components/Pages/Templates/Create";

const { displayName } = config;

export default function TemplateCreate(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Template Create`;
  }, []);

  return (
    <Layout>
      <TemplateCreateContent />
    </Layout>
  );
}
